import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Edit2, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, Spinner, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import AddVoucherModalForm from "./modals/AddVoucherModal";
import Moment from "moment";
import DeleteProductLaunchingModal from "./modals/DeleteProductLaunchingModal";
import AddManualReporting from "./modals/AddManualReporting";
import AddAdidasVouchers from "./modals/AddAdidasVouchers";
import AddVoucherInfoModalForm from "./modals/AddVoucherInfoModal";
import UpdateProductLaunchingForm from "./modals/UpdateProductLaunchingModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import {CiWarning} from "react-icons/ci";
import InfiniteScroll from "react-infinite-scroll-component";
import { apiFetch, API, getMarket } from "../services/api";

function getProductsLaunching() {
    return apiFetch(API.products + '/products-launching', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getMerchands() {
    return apiFetch(API.products + '/merchants', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function updateState(productLaunching, checked) {
    productLaunching.enable = checked
    productLaunching.language = getMarket()
    return apiFetch(API.products + '/product-launching', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(productLaunching)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class ProductsLaunchingList extends Component{
    state = {
        productLaunchings: [],
        countOfEmptyDescription: 0,
        countOfEmptyEvents: 0,
        isOpen: false,
        isVouchersOpen: false,
        errors: null,
        lastEvaluatedKey: null,
        selectedProductLaunching : {
            declinations: [],
            name: "",
            description: "",
            metaTitle:"",
            metaDescription:"",
        }
    }

    async componentDidMount() {
        await getProductsLaunching().then(data => {
            this.setState({ productLaunchings: data ? data : [], errors : "", loading: false })
        }).catch(err =>
                console.log(err),
            this.setState({errors: "error while getting productLaunchings"})
        );
        await getMerchands().then(data => {
            this.setState({ availableMerchands: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting merchands"})
        );
    };

    closeModal = () => this.setState({ isOpen: false, selectedProductLaunching: {
            events: [],
            name: "",
            description: "",
            metaTitle:"",
            metaDescription:"",
        } });

    render(){

        return(
            <div className="products-list">
                <Row>
                    <Col sm={4} className="products-buttons">
                        <span>Nombre de lancements de produits : {this.state.productLaunchings.length}</span>
                    </Col>

                    <Col sm={8} className="products-buttons" style={{textAlign:"right"}}>
                        <Button className="add-product-button " variant="secondary" type="submit"onClick={(e) => this.setState({isOpen : true})}>Ajouter un lancement de produits</Button>
                    </Col>
                </Row>
                { (!this.state.productLaunchings) ? <p> Aucun lancement de produits disponible.</p>
                    :
                    <Table responsive>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nom</th>
                                <th>Nombre coloris</th>
                                <th>Date de lancement</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                                {!this.state.loading ? this.state.productLaunchings.length > 0 && this.state.productLaunchings.map(productLaunching => (
                            <tr key={productLaunching.id}>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Afficher le produit sur le site</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={productLaunching.enable}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateState(productLaunching, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>{productLaunching.name}</td>
                                <td>{productLaunching.declinations ? productLaunching.declinations.length : 0}</td>
                                <td>{Moment(productLaunching.launchingDate).format('DD-MM-YYYY').toString()}</td>                                
                                <td className="table-action">
                                    <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpen : true, selectedProductLaunching : productLaunching})}/>
                                </td>
                                <td className="table-action">
                                    <Trash className="align-middle" size={18}onClick={(e) => this.setState({isDelete: true, selectedProductLaunching: productLaunching})} />
                                </td>
                            </tr>
                        )) : null}                                          
                        </tbody>
                    </Table>
                    }
                { this.state.isOpen ?
                    <UpdateProductLaunchingForm
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        availableMerchands={this.state.availableMerchands}
                        selectedProductLaunching={this.state.selectedProductLaunching}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteProductLaunchingModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedProductLaunching}
                        selectedCategory="productLaunching"
                    />
                    :
                    null
                }
            </div>
        );

    }

}